export enum HttpStatus {
	// Success
	OK = 200,
	Created = 201,
	Accepted = 202,
	NoContent = 204,

	// Redirects
	Moved = 301,
	Found = 302,

	// Client error
	BadRequest = 400,
	Unauthorized = 401,
	Forbidden = 403,
	NotFound = 404,
	Conflict = 409,

	// Server error
	ServerError = 500,
}

export interface StatusError {
	status: number;
}
